// src/calendarLocalizer.js
import { dateFnsLocalizer } from "react-big-calendar";
import format from "date-fns/format";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import getDay from "date-fns/getDay";

// date-fns locales:
import enUS from "date-fns/locale/en-US";
import fr from "date-fns/locale/fr";
import tr from "date-fns/locale/tr";
import de from "date-fns/locale/de";
import es from "date-fns/locale/es";
import pt from "date-fns/locale/pt";
import nl from "date-fns/locale/nl";
import el from "date-fns/locale/el";

// map your i18n language keys to date-fns locales
export const locales = {
  en: enUS,
  fr,
  tr,
  de,
  es,
  pt,
  nl,
  el,
};

export const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});
